(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbb-channel-player"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bbb-cp[data-channel-player]').forEach(cp=>{
 if(cp.dataset.cpReady)return;cp.dataset.cpReady='true';
 const stage=cp.querySelector('[data-cp-stage]'),poster=stage.innerHTML,ctl=[...cp.querySelectorAll('[data-cp-cmd]')],NOCK='https://www.youtube-nocookie.com';
 const send=fn=>{const f=stage.querySelector('iframe');if(!f||!f.contentWindow)return;f.contentWindow.postMessage(JSON.stringify({event:'command',func:fn,args:[]}),NOCK)};
 ctl.forEach(b=>b.addEventListener('click',()=>send(b.dataset.cpCmd)));
 cp.addEventListener('click',e=>{
  if(!e.target.closest('[data-cp-start]'))return;
  const f=document.createElement('iframe');
  f.title=cp.querySelector('.bbb-cp__label').textContent;
  const ids=cp.dataset.ids.split(',');f.src='https://www.youtube-nocookie.com/embed/'+ids[0]+'?playlist='+ids.join(',')+'&loop=1&rel=0&playsinline=1&autoplay=1&enablejsapi=1&origin='+encodeURIComponent(location.origin);
  f.id='cp-frame-'+cp.id;
  f.allow='autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';
  f.referrerPolicy='strict-origin-when-cross-origin';
  stage.replaceChildren(f);
  cp.classList.add('is-live');ctl.forEach(b=>b.tabIndex=0);
  /* IFrame API handshake (postMessage protocol, nocookie origin only, no extra script from youtube.com) */
  const hello=()=>{try{f.contentWindow.postMessage(JSON.stringify({event:'listening',id:f.id,channel:'widget'}),NOCK)}catch(_){}};
  f.addEventListener('load',()=>{hello();setTimeout(hello,600)});
  document.dispatchEvent(new CustomEvent('atb:engagement',{detail:{name:'channel_player_open'}}));
 });
 /* "Up next" column (desktop, 1024px and up): a few compact rows from the pool, none of them in the grid's first screen */
 if(cp.hasAttribute('data-upnext')){
  const side=cp.querySelector('[data-cp-side]'),rows=cp.querySelector('[data-cp-rows]'),mq=matchMedia('(min-width:1024px)');let built=false;
  const fit=()=>{if(side.hidden)return;const h=stage.getBoundingClientRect().height;side.style.setProperty('--stage-h',h+'px');
   const li=[...rows.children];li.forEach(x=>x.hidden=false);
   for(let i=li.length-1;i>=4&&side.scrollHeight>h+1;i--)li[i].hidden=true;};
  const build=()=>{if(built||!mq.matches)return;built=true;
   (window.bbbPoolQ=window.bbbPoolQ||[]).push(P=>{
    P.load(cp.dataset.pool).then(d=>{
     const pick=d.videos.slice(1,7);
     pick.forEach(v=>{
      const li=document.createElement('li');
      li.innerHTML='<a class="bbb-cp__row" href="https://www.youtube.com/watch?v='+v.id+'" data-video-title="'+P.esc(v.title)+'"><span class="bbb-cp__rimg"><span class="bbb-cp__rdur"><span class="atb-gal__sr" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Length: </span>'+P.fmt(v.secs)+'</span></span><span><span class="bbb-cp__rtitle">'+P.esc(v.title)+'</span><span class="bbb-cp__rby">Big Boy’s YouTube channels'+(v.explicit?' · Explicit language':'')+'</span></span></a>';
      const im=li.querySelector('.bbb-cp__rimg');im.insertBefore(P.thumb(v.id,'mq',v.guest+': '+v.title),im.firstChild);
      rows.appendChild(li);
     });
     side.hidden=false;fit();
     if('ResizeObserver' in window)new ResizeObserver(fit).observe(stage);else addEventListener('resize',fit);
    }).catch(()=>{});
   });
  };
  build();if(mq.addEventListener)mq.addEventListener('change',build);
  rows.addEventListener('click',e=>{const a=e.target.closest('a.bbb-cp__row');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();
   document.dispatchEvent(new CustomEvent('bbb:open-video',{detail:{id:new URL(a.href).searchParams.get('v'),title:a.dataset.videoTitle,href:a.href,trigger:a}}));});
 }
 /* one video at a time: opening a tile player puts the channel player back to its poster */
 document.addEventListener('bbb:media-open',()=>{if(stage.querySelector('iframe')){stage.innerHTML=poster;cp.classList.remove('is-live');ctl.forEach(b=>b.tabIndex=-1)}});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-essentials"] && !Shopify.designMode) return;
  try {
    
(function(){function openReviewForm(){var id=decodeURIComponent(location.hash.slice(1));if(!id.startsWith('bbb-review-form-'))return;var panel=document.getElementById(id);if(panel&&panel.matches('.bbb-review-form-panel'))panel.open=true;}openReviewForm();window.addEventListener('hashchange',openReviewForm);document.addEventListener('click',function(event){var link=event.target.closest('.bbb-essential-heading a');if(!link)return;var id=link.hash.slice(1);var panel=document.getElementById(id);if(panel)panel.open=true;});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  function openTopic() {
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); }
    catch (_) { return; }
    if (!id) return;
    var node = document.getElementById(id);
    if (node && node.matches('.bbb-info-faq details')) node.open = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openTopic, { once: true });
  else openTopic();
  window.addEventListener('hashchange', openTopic);
  window.addEventListener('pageshow', openTopic);
  document.addEventListener('shopify:section:load', openTopic);
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var link = event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash === location.hash) openTopic();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-video-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.atb-gal').forEach(root=>{
 if(root.dataset.galReady)return;root.dataset.galReady='true';
 const dialog=root.querySelector('dialog'),player=root.querySelector('[data-watch-player]');let trigger;
 (window.bbbPoolQ=window.bbbPoolQ||[]).push(P=>{
  const g=root.querySelector('[data-gal-grid]'),more=root.querySelector('[data-gal-more]'),btn=root.querySelector('[data-gal-more-btn]'),end=root.querySelector('[data-gal-end]'),B=14;
  const fail=()=>{g.removeAttribute('aria-busy');more.hidden=false;btn.hidden=true;end.hidden=false;};
  P.load(root.dataset.pool).then(d=>{
   const items=d.videos.slice();let shown=0,io=null;
   window.bbbGridFirst=items.slice(0,B).map(v=>v.id);document.dispatchEvent(new CustomEvent('bbb:grid-order',{detail:{first:window.bbbGridFirst}}));
   const tile=v=>{
    const li=document.createElement('li');li.className='atb-gal__item';li.dataset.cat=v.cat;
    li.innerHTML='<a class="atb-gal__card" href="https://www.youtube.com/watch?v='+v.id+'" data-atb-video data-video-title="'+P.esc(v.title)+'"><span class="atb-gal__image"><span class="atb-gal__play" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg></span><span class="atb-gal__dur"><span class="atb-gal__sr">Length: </span>'+P.fmt(v.secs)+'</span></span><span class="atb-gal__caption"><span class="atb-gal__title">'+P.esc(v.title)+'</span><span class="atb-gal__by">Big Boy’s YouTube channels'+(v.explicit?' · Explicit language':'')+'</span></span></a>';
    const im=li.querySelector('.atb-gal__image');im.insertBefore(P.thumb(v.id,'max',v.guest+': '+v.title,v.hq),im.firstChild);
    return li;
   };
   const reveal=()=>{
    const f=document.createDocumentFragment();
    items.slice(shown,shown+B).forEach(v=>f.appendChild(tile(v)));
    shown=Math.min(items.length,shown+B);g.appendChild(f);g.dataset.shown=shown;
    const done=shown>=items.length;btn.hidden=done;end.hidden=!done;
    if(done&&io){io.disconnect();io=null;}
   };
   g.dataset.total=items.length;g.removeAttribute('aria-busy');
   reveal();more.hidden=false;
   if('IntersectionObserver' in window){
    io=new IntersectionObserver(es=>{if(es.some(e=>e.isIntersecting)&&shown<items.length){reveal();if(io){io.unobserve(more);io.observe(more);}}},{rootMargin:'0px 0px 500px 0px'});
    io.observe(more);
   }
   btn.addEventListener('click',()=>{reveal();});
  }).catch(fail);
 });
 const openVideo=(id,title,href,link)=>{document.dispatchEvent(new CustomEvent('bbb:media-open'));trigger=link;root.querySelector('[data-watch-title]').textContent=title;root.querySelector('[data-watch-fallback]').href=href;const frame=document.createElement('iframe');frame.title=title;frame.src='https://www.youtube-nocookie.com/embed/'+id+'?rel=0&playsinline=1&autoplay=1';frame.allow='autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';frame.referrerPolicy='strict-origin-when-cross-origin';player.replaceChildren(frame);dialog.showModal();document.dispatchEvent(new CustomEvent('atb:engagement',{detail:{name:'video_open',video:id}}));};
 root.addEventListener('click',e=>{const link=e.target.closest('[data-atb-video]');if(!link||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const url=new URL(link.href),id=url.searchParams.get('v');if(!/^[\w-]{11}$/.test(id||''))return;e.preventDefault();openVideo(id,link.dataset.videoTitle,link.href,link);});
 document.addEventListener('bbb:open-video',e=>{const d=e.detail||{};if(!/^[\w-]{11}$/.test(d.id||''))return;openVideo(d.id,d.title||'',d.href||('https://www.youtube.com/watch?v='+d.id),d.trigger);});
 root.querySelector('[data-watch-close]').addEventListener('click',()=>dialog.close());root.querySelector('[data-watch-fallback]').addEventListener('click',()=>{setTimeout(()=>dialog.close(),0);});dialog.addEventListener('close',()=>{player.replaceChildren();trigger&&trigger.focus();});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-watch"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.atb-watch').forEach(root=>{
 if(root.dataset.watchReady)return;root.dataset.watchReady='true';
 const dialog=root.querySelector('dialog'),player=root.querySelector('[data-watch-player]');let trigger;
 (window.bbbPoolQ=window.bbbPoolQ||[]).push(P=>{
  const gs=root.querySelectorAll('[data-watch-group]'),vp=root.querySelector('.atb-watch__viewport');
  P.load(root.dataset.pool).then(d=>{
   const picks=d.videos.filter(v=>v.home!==false).slice(0,6);
   gs.forEach((grp,ci)=>{
    picks.forEach((v,i)=>{
     const a=document.createElement('a');a.className='atb-watch__video';a.dataset.cat=v.cat;a.href='https://www.youtube.com/watch?v='+v.id;a.setAttribute('data-atb-video','');a.dataset.videoTitle=v.title;
     a.innerHTML='<div class="atb-watch__image"><span class="atb-watch__play" aria-hidden="true">\u25B6</span><span class="atb-watch__number" aria-hidden="true">'+(i<9?'0':'')+(i+1)+'</span>'+(v.explicit?'<span class="atb-watch__exp">Explicit language</span>':'')+'</div><div class="atb-watch__caption"><h3>'+P.esc(v.guest)+'</h3><p>'+P.esc(v.title)+'</p><span aria-hidden="true">\u2197</span></div>';
     const im=a.querySelector('.atb-watch__image');im.insertBefore(P.thumb(v.id,'mq',''),im.firstChild);
     grp.appendChild(a);
    });
   });
   root.dataset.reelReady='true';vp.removeAttribute('aria-busy');
  }).catch(()=>{});
 });
 root.addEventListener('click',e=>{const link=e.target.closest('[data-atb-video]');if(!link||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const url=new URL(link.href),id=url.searchParams.get('v');if(!/^[\w-]{11}$/.test(id||''))return;e.preventDefault();document.dispatchEvent(new CustomEvent('bbb:media-open'));trigger=link;root.querySelector('[data-watch-title]').textContent=link.dataset.videoTitle;root.querySelector('[data-watch-fallback]').href=link.href;const frame=document.createElement('iframe');frame.title=link.dataset.videoTitle;frame.src='https://www.youtube-nocookie.com/embed/'+id+'?rel=0&playsinline=1&autoplay=1';frame.allow='autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';player.replaceChildren(frame);dialog.showModal();document.dispatchEvent(new CustomEvent('atb:engagement',{detail:{name:'video_open',video:id}}));});
 root.querySelector('[data-watch-close]').addEventListener('click',()=>dialog.close());root.querySelector('[data-watch-fallback]').addEventListener('click',()=>{setTimeout(()=>dialog.close(),0);});dialog.addEventListener('close',()=>{player.replaceChildren();trigger?.focus();});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-welcome"] && !Shopify.designMode) return;
  try {
    
const revealWelcomeSignup = () => {
  document.querySelectorAll('.atb-welcome__signup').forEach(signup => {
    if (window.location.hash === '#' + signup.id || signup.querySelector('[role="alert"], [role="status"]')) signup.open = true;
  });
};
revealWelcomeSignup();
window.addEventListener('hashchange', revealWelcomeSignup);
document.addEventListener('shopify:section:load', revealWelcomeSignup);
document.addEventListener('click', event => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const target = new URL(link.href, window.location.href);
  if (target.origin !== window.location.origin || target.pathname !== window.location.pathname || target.hash !== '#join') return;
  const signup = document.getElementById('join');
  if (signup?.matches('.atb-welcome__signup')) signup.open = true;
});
document.addEventListener('invalid', event => {
  const signup = event.target.closest('.atb-welcome__signup');
  if (signup) signup.open = true;
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbb-west-coast"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bbb-print-preview')) {
  customElements.define('bbb-print-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.previewReady) return;
      this.previewReady = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-print]');
        if (!button || !this.contains(button)) return;
        const color = button.dataset.print;
        this.querySelectorAll('[data-print-panel]').forEach(panel => { panel.hidden = panel.dataset.printPanel !== color; });
        this.querySelectorAll('button[data-print]').forEach(control => { control.setAttribute('aria-pressed', String(control === button)); });
        const label = this.querySelector('[data-print-label]');
        if (label) label.textContent = button.dataset.label;
        const link = this.querySelector('[data-product-link]');
        const source = this.querySelector('[data-variant-links]');
        if (link && source) {
          try {
            const matches = JSON.parse(source.textContent).filter(variant => variant.options.includes(button.dataset.label));
            const match = matches.find(variant => variant.available) || matches[0];
            if (match) link.href = match.url;
          } catch (error) { /* Preserve the original product URL. */ }
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
